import { Outlet, useNavigate } from "react-router-dom";
import React, { useState, useEffect } from "react";
import Sidebar from "../layout/Sidebar";
import Header from "../layout/Header";
import { useAuth } from "./AuthContext";
import axios from "axios";
import { API_BASE_URL } from "../../config";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";

const PrivateRoute = () => {
  const {
    jwt,
    isAuthenticated,
    updateData,
    updatePermissions,
    permissions,
    data,
    logout,
    roleName,
    updateRoleName,
  } = useAuth();
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isCollapsed, setIsCollapsed] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth <= 768;
      setIsMobile(mobile);
      if (mobile) {
        setIsCollapsed(true);
      } else {
        setIsCollapsed(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Calculate sidebar width: 0/250 on mobile, always 250 on desktop
  const sidebarWidth = isMobile ? (isCollapsed ? 0 : 250) : 250;

  useEffect(() => {
    // Fetch data only if it's not already available
    if (!data) {
      axios
        .get(`${API_BASE_URL}/api/home`, {
          withCredentials: true,
          headers: {
            "x-token": jwt,
          },
        })
        .then((res) => {
          if (res.data.error) {
            console.log("error: " + res.data.error);
            navigate("/");
          }
          console.log("isAuthenticated: " + isAuthenticated());
          updateData(res.data.userData);
          updatePermissions(res.data.permissionsData);
          updateRoleName(res.data.roleName);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [
    jwt,
    navigate,
    isAuthenticated,
    updateData,
    data,
    updatePermissions,
    updateRoleName,
  ]);

  return (
    isAuthenticated() &&
    data && (
      <div className="flex min-h-screen w-full bg-canvas">
        {/* Sidebar - Fixed Position */}
        <div
          className="fixed left-0 top-0 h-screen z-[1000] transition-[width] duration-300"
          style={{ width: `${sidebarWidth}px` }}
        >
          <Sidebar
            isCollapsed={isCollapsed}
            setIsCollapsed={setIsCollapsed}
            data={data}
            permissions={permissions}
            roleName={roleName}
            onLogout={logout}
            isSuperAdmin={roleName === "superadmin"}
          />
        </div>

        {/* Main Content - Dynamic margin for responsiveness */}
        <div
          className="h-screen flex flex-col overflow-hidden transition-[margin-left,width] duration-300 bg-info-50/30 relative"
          style={{
            marginLeft: isMobile ? "0px" : `${sidebarWidth}px`,
            width: isMobile ? "100%" : `calc(100% - ${sidebarWidth}px)`,
          }}
        >
          {isMobile && (
            <div className="fixed top-0 left-0 w-full h-[50px] bg-primary z-[1100] flex justify-end items-center px-4 gap-2.5 shadow-[0_2px_10px_rgba(0,0,0,0.1)]">
              <span className="text-white font-black text-[1.1rem] tracking-wide uppercase">
                Jothilinga
              </span>
              <button
                className="mobile-menu-toggle bg-transparent text-white border-none p-1 flex items-center justify-center cursor-pointer"
                onClick={() => setIsCollapsed(!isCollapsed)}
              >
                <MenuRoundedIcon className="text-[1.8rem]" />
              </button>
            </div>
          )}
          {!isMobile && <Header />}
          <div
            className="flex-1 overflow-y-auto overflow-x-hidden box-border w-full"
            style={{
              padding: isMobile ? "65px 12px 20px" : "24px",
            }}
          >
            <Outlet />
          </div>
        </div>
      </div>
    )
  );
};

export default PrivateRoute;

